import React from 'react';
import '../Styles/LandingPage.css';
const BookNowButton = ({ onClick, isRedirecting }) => (
  <button
    className="landingpagebutton w-full max-w-lg h-12 bg-blue-950 text-white font-bold rounded-full border border-gray-300 mt-4 hover:bg-blue-900 transition duration-300"
    onClick={onClick}
    disabled={isRedirecting}
  >
    {isRedirecting ? 'Loading...' : 'Book Now'}
  </button>
);

export default BookNowButton;
